/* jshint esnext: true */

const mazes = {

	currentMaze: null,

	tiles: [],

	addons: [],

	directions: [],


	/**
	 * Create a new maze.
	 */
	create: function( scene ) {

		if ( null !== this.currentMaze ) {
			this.currentMaze.tilemap.destroy();
		}

		// Reset old tiles.
		this.tiles = [];

		map.design();

		// When loading from an array, make sure to specify the tileWidth and tileHeight
		let tilemap = scene.make.tilemap(
			{
				key: 'maze',
				data: map.createTiles(),
				tileWidth: 16,
				tileHeight: 16
			}
		);

		let listLength = Object.keys( tilesets ).length;

		for ( let i = 1; i <= listLength; i++ ) {
			this.tiles[ i ] = tilemap.addTilesetImage( 'maze' + i );
		}

		this.currentMaze = {
			tilemap,
			layer: tilemap.createStaticLayer( 0, this.tiles[ gameData.currentItem ], 0, 0 )
		};

		this.getDirections();

		this.doAddons( scene );

		return this.currentMaze.layer;

	},


	/**
	 * Setup the map dimensions.
	 */
	setup: ( width = 16, height = 16 ) => {

		settings.width = width;
		settings.height = height;

	},


	/**
	 * Convert the map layout into a list of allowed directions for each tile.
	 */
	getDirections: function() {

		this.directions = [];

		// Initialize size of array and set everything to 0 to show it's not in use.
		for ( let y = 0; y < settings.height; y++ ) {

			this.directions[ y ] = [];

			for ( let x = 0; x < settings.width; x++ ) {

				let tile = map.map[ y ][ x ];

				this.directions[ y ][ x ] = [];
				// this.directions[ y ][ x ].push( tile );

				if ( tile & 2 ) {
					this.directions[ y ][ x ].push( 'R' );
				}
				if ( tile & 4 ) {
					this.directions[ y ][ x ].push( 'L' );
				}
				if ( tile & 8 ) {
					this.directions[ y ][ x ].push( 'D' );
				}
				if ( tile & 16 ) {
					this.directions[ y ][ x ].push( 'U' );
				}

			}

		}

	},


	/**
	 *
	 */
	doAddons: function( scene ) {

		// Store the addon properties.
		mazes.addons = [];

		for ( let y = 0; y < settings.height; y++ ) {
			mazes.addons[ y ] = [];
			for ( let x = 0; x < settings.width; x++ ) {
				let value = '';
				if ( 0 !== map.map[ y ][ x ] && 32 !== map.map[ y ][ x ] ) {
					value = '-';
				}
				mazes.addons[ y ][ x ] = value;
			}
		}

		mazes.addAddons( 'energy', 50 );
		mazes.addAddons( 'money', 40 );
		mazes.addAddons( 'money-10', 60 );
		mazes.addAddons( 'time', 40 );

		addons.add( scene );

	},

	/**
	 *
	 */
	addAddons: ( type = '', amount_divider = 40 ) => {

		let amount = Math.floor( ( settings.width * settings.height ) / amount_divider );
		let count = 0;

		// while ( true ) {
		while ( count < amount ) {

			let x = rando.range( 1, settings.width - 1 );
			let y = rando.range( 1, settings.height - 2 );

			if ( '-' === mazes.addons[ y ][ x ] ) {
				mazes.addons[ y ][ x ] = type;
				count++;
			}

		}

	},


	/**
	 * Change the tileset used for the map.
	 */
	setTileset: ( id ) => {

		mazes.currentMaze.layer.tileset[ 0 ] = mazes.tiles[ id ];

	}

};